// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"vendors-node_modules_tabler_icons-react_dist_esm_icons_IconSquareFilled_js-node_modules_manti-87d294":"1b8ea595cbd755abcdfb","app_javascript_src_components_ExplorerBlocks_tsx":"b4e9b5f9b248d4a722c0"}[chunkId] + ".chunk.js";
};